export default __webpack_public_path__ + "static/media/bat-logo-white.29f23535.svg";